module.exports = "// создание клиента\r\n$$var_cc = new nsd.CryptoClient();\r\nconsole.log('success');\r\n"